import React, { ReactElement } from "react";

interface Props {
  sidebar: ReactElement;
  sidebarSticky: ReactElement;
  children: ReactElement;
}

export default function LeftAsideLayout({
  sidebar,
  sidebarSticky,
  children,
}: Props) {
  return (
    <div className="container">
      <div className="bg-white mt-5">
        <div id="page">
          <div className="flex flex-col lt:flex-row">
            <div className="flex-none w-full lt:max-w-xs">
              {sidebar}
              {sidebarSticky && (
                <div className="lt:sticky lt:top-0">{sidebarSticky}</div>
              )}
            </div>
            <div className="flex-none w-full lt:flex-auto">
              {children}
              <div className="clears" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
